import { useState } from 'react';
import { debounce } from 'lodash';
import { ComboFilterCategory } from '@lithos/ComboFilter';
import { FlexGroup, Input, ComboFilter } from '@lithos';

const TableSelectors = ({
  hasAnyFilters,
  activeFilterCount,
  handleResetFilters,
  categories,
  onSearchInputChange,
  testId,
}: {
  hasAnyFilters: boolean;
  activeFilterCount: number;
  handleResetFilters: () => void;
  categories: ComboFilterCategory[];
  onSearchInputChange: (query: string) => void;
  testId?: string;
}) => {
  const [selectedCategory, setSelectedCategory] = useState<ComboFilterCategory | undefined>(undefined);
  const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined);
  return (
    <FlexGroup padding="0">
      <Input
        value={searchQuery}
        onChange={debounce(onSearchInputChange, 300)}
        icon="Search"
        placeholder="Search by name or ID"
        type="string"
        size="s"
        disabled={false}
        testId={testId}
      />
      <ComboFilter
        icon={'Filters'}
        hasAnyActiveFilters={hasAnyFilters}
        activeFilterCount={activeFilterCount}
        resetFilters={handleResetFilters}
        categories={categories}
        setSelectedCategory={setSelectedCategory}
        selectedCategory={selectedCategory}
        testId={testId}
      />
    </FlexGroup>
  );
};

export default TableSelectors;
